export const ConversationAnalysisStyles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    paddingY: "2rem",
  },
  dateFieldsContianer: {
    display: "flex",
    alignSelf: "flex-end",
    gap: 2,
  },
  filterContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    gap: "1rem",
    // padding: "1.5rem",
    flexWrap: "wrap",
  },
  metricsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1.5rem",
  },
  metricCard: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
    gap: "0.5rem",
    backgroundColor: "rgb(255 255 255)",
    borderRadius: "8px",
    boxShadow:
      "0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    transition: "transform 0.4s ease",
    ":hover": {
      transform: "scale(1.02)",
    },
  },
  metricCardTopContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  metricCardBottomContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  cardHeading: {
    fontWeight: "400",
  },
  cardContent: {
    fontWeight: "600",
    fontSize: "1.3rem",
  },
  sessionHistoryContainer: {
    width: "45vw",
    height: "70vh",
    overflowY: "scroll",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    boxShadow:
      "0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    minHeight: "500px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" },
  },
  conversationContainer: {
    width: "100%",
    height: "70vh",
    overflowY: "scroll",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    boxShadow:
      "0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    minHeight: "500px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" },
  },
  conversationHeadingContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "1rem",
    position: "sticky",
    top: 0,
    backgroundColor: "#f5f5f5 ",
    zIndex: 999,
  },
  sessionsHeadingContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    backgroundColor: "#f5f5f5 ",
    zIndex: 999,
  },
  sessionDetailsCardContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    padding: "1rem",
    gap: "0.5rem",
    boxShadow:
      "0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#f5f5f5 ",
    },
  },
  sessionContent: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  sessionEmailContainer: {
    width: "100%",
    display: "flex",
    fontSize: "0.875rem",
    gap: 1,
    alignItems: "center",
  },
  sessionDatesContianer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 599px)": {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
  },
  sessionDateAndIcon: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "0.8rem",
    fontStyle: "italic",
    color: "#64748B",
  },
  sessionHistorySkeletonContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 2,
  },
  sessionHistoryCardsListContainer: {
    width: "100%",
    display: "flex",
    padding: "1rem",
    gap: "1rem",
    flexDirection: "column",
    alignItems: "center",
  },
  chatMessageContainer: {
    backgroundColor: "#ececec",
    borderRadius: "4px",
    padding: "10px",
    maxWidth: "60%",
  },
  chatContainer: {
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  conversationsDataContainer: {
    display: "flex",
    width: "100%",
    alignItems: "start",
    justifyContent: "center",
    gap: "1.5rem",
  },
  answerContainer: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "wrap",
  },
  feedBackIconContainer: {
    display: "flex",
    justifyContent: "end",
    alignItems: "flex-end",
    width: "100%",
  },
};
